import { IBreakpoints } from "../theme.types";

export const breakpoints: IBreakpoints = {
  base: 0,
  mobile: 320,
  tablet: 768,
  computer: 992,
  largeScreen: 1200,
  widescreen: 1920,
};
